/**
 * Работа с авторизацией в Drupal
 */

const user = {
  depend: ['Работает в логике Drupal'],
  /*  state: {
    isActive: false
  },
  activate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('active: user')
    }

    this.state.isActive = true
  }, */
  isAuth () {
    /**
     * Самый надёжный способ - по глобальной метке из бэкенд
     */
    if (window.drupal_user_is_logged_in) return true

    /**
     * Если метки нет, то проверяем другие признаки
     */
    const blockUser = document.querySelector('#block-user-1 > div.title')

    // Регулярное выражение для поверхостной (неполной) проверки email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    // Проверяем содержимое
    if (blockUser && emailRegex.test(blockUser.textContent.trim())) {
      return true
    } else {
      return false
    }
  }
}
export default user
